// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {219: "b655b4fc4e73b0f8",228: "c8cf555ba043e006",49: "8777d72297701e79",67: "49db1feb2e4327d2",}[chunkId] + ".js"
}